import { Injectable } from '@angular/core';

@Injectable()
export class TraceManagementStateService {
    private readonly _dateNow = new Date();
    private readonly _previousDate =  new Date(Date.now() - 1*24*60*60*1000);
    private state = {
        dateMin : this._previousDate,
        dateMax : this._dateNow,
        category: '',
        fileNameFilter: ''

    };

    constructor() { }

    public getState() {
        return this.state;
    }

    public setState(state){
        this.state = state;
    }

    public resetState() {
      this.state = {
          dateMin : new Date(),
          dateMax : new Date(),
          category: '',
          fileNameFilter: ''

        };
    }

}
